import { Wrapper } from '@/components/OpenFeature/Wrapper';
import { useTranslation } from '@/i18n';
import { Loading } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, Suspense, useState } from 'react';
import { AiAgentMainSetting } from './components/AiAgentMainSetting';
import { AiAgentServicesSetting } from './components/AiAgentServicesSetting';
import { useGetAiAgentsSetting } from './hooks/useGetAiAgentsSetting';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

export const InnerAiAgentsSetting: FC = () => {
  const { t } = useTranslation();
  const { isAiAgentEnabled, mappedAiAgentServiceSettings } =
    useGetAiAgentsSetting();
  const [isEditingServices, setIsEditingServices] = useState(false);
  return (
    <Wrapper isProto={false}>
      <div className={cx('aiAgentsSettingContainer')}>
        <div className={cx('aiAgentsSettingHeading')}>
          <h1 className={cx('aiAgentsSettingHeadingText')}>
            {t('ai_agents_setting')}
          </h1>
        </div>
        <AiAgentMainSetting
          isEnabled={isAiAgentEnabled}
          isEditMode={isEditingServices}
        />
        <AiAgentServicesSetting
          isMainSettingEnabled={isAiAgentEnabled}
          setIsEditingServices={setIsEditingServices}
          isEditingServices={isEditingServices}
          {...mappedAiAgentServiceSettings}
        />
      </div>
    </Wrapper>
  );
};

const FallBackLoading = () => {
  return (
    <div className={cx('loadingContainer')}>
      <Loading size='large' color='success' />
    </div>
  );
};

export const AiAgentsSetting: FC = () => {
  return (
    <Suspense fallback={<FallBackLoading />}>
      <InnerAiAgentsSetting />
    </Suspense>
  );
};
